import { normalizeStr } from "utils/general/strings";

/**
 * Compare two strings
 * @param {string} a The first string
 * @param {string} b The second string
 * @returns 1 if a > b, -1 if a < b, 0 if a === b
 */
export function compareStrings(a, b) {
    if (normalizeStr(b) < normalizeStr(a)) {
        return -1;
    }
    if (normalizeStr(b) > normalizeStr(a)) {
        return 1;
    }
    return 0;
}
